import { render } from "./Area.vue?vue&type=template&id=5fb405fa&scoped=true"
import script from "./Area.vue?vue&type=script&lang=js"
export * from "./Area.vue?vue&type=script&lang=js"

import "./Area.vue?vue&type=style&index=0&id=5fb405fa&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb405fa"]])

export default __exports__